module.exports = __webpack_public_path__ + "static/media/klubf5.0b32623d.png";